const p = (id, nameMn, nameRu, nameEn, min, max) => ({
  id, nameMn, nameRu, nameEn, name: nameRu, price: '', priceMinMnt: min, priceMaxMnt: max || null,
});

/** Услуги по презентации uilchilgee.pptx (POWER auto service). */
export const fallbackServices = [
  {
    id: 1,
    slug: 'segserdi-onoshilgoo',
    icon: '📳',
    title: 'Вибродиагностика',
    titleMn: 'Сэгсэрдэг оношилгоо',
    titleRu: 'Вибродиагностика',
    titleEn: 'Vibration diagnostics',
    shortDescription: 'Механическая диагностика с имитацией дорожных нагрузок',
    shortDescriptionMn: 'Замын ачааллыг дуурайлган механикаар оношлох',
    shortDescriptionRu: 'Механическая диагностика с имитацией дорожных нагрузок',
    shortDescriptionEn: 'Mechanical diagnostics simulating road loads',
    fullDescriptionMn: 'Таны автомашинд механик аргаар, тусгай зориулалтын техник хэрэгслээр замын саад, бартааг үүсгэх маягаар эвдрэл, гэмтлийг тодорхойлдог үйлчилгээ.',
    fullDescriptionRu: 'Диагностика неисправностей и повреждений специальным оборудованием, имитирующим дорожные неровности и нагрузки на автомобиль.',
    fullDescriptionEn: 'We detect faults and damage using special tools that simulate road bumps and loads on your vehicle.',
    prices: [
      p(1, 'Суудлын автомашин', 'Легковой автомобиль', 'Passenger car', 30000),
      p(2, 'Том машин / джип', 'Крупный автомобиль / внедорожник', 'Large vehicle / SUV', 50000),
    ],
  },
  {
    id: 2,
    slug: 'kompyuter-onoshilgoo',
    icon: '💻',
    title: 'Компьютерная диагностика',
    titleMn: 'Компьютер оношилгоо',
    titleRu: 'Компьютерная диагностика',
    titleEn: 'Computer diagnostics',
    shortDescription: 'Считывание кодов ошибок, проверка ECU и датчиков',
    shortDescriptionMn: 'ECU алдааны код, систем, Live data шалгалт',
    shortDescriptionRu: 'Считывание кодов ошибок ECU, проверка систем и датчиков, live data',
    shortDescriptionEn: 'ECU fault codes, systems and sensors, live data',
    fullDescriptionMn: 'Электрон чип хяналт, мониторын мэдрэгчүүдээр дамжуулж доголдол, гэмтлийг оношлох: ECU/компьютерийн алдааны код унших, устгах; хөдөлгүүр, хроп, ABS, airbag зэрэг систем; мэдрэгчийн ажиллагаа; Live data-гаар бодит үзүүлэлтүүд.',
    fullDescriptionRu: 'Диагностика через электронный блок и датчики: чтение и сброс кодов ошибок ECU; проверка двигателя, трансмиссии, ABS, подушек безопасности; контроль датчиков и параметров в реальном времени (live data).',
    fullDescriptionEn: 'Electronic control unit and sensors: read and clear ECU fault codes; check engine, transmission, ABS, airbags; sensor operation and live data monitoring.',
    prices: [p(3, 'Бүх төрлийн автомашин', 'Все типы автомобилей', 'All vehicle types', 25000)],
  },
  {
    id: 3,
    slug: 'duguyn-balance-tohirgoo',
    icon: '⚖️',
    title: 'Балансировка колёс',
    titleMn: 'Дугуйн баланс тохиргоо',
    titleRu: 'Балансировка колёс',
    titleEn: 'Wheel balancing',
    shortDescription: 'Балансировка с подбором грузиков на диске',
    shortDescriptionMn: 'Жингийн хуваарилалтаар обуд дээр ачаа зүүх',
    shortDescriptionRu: 'Балансировка с подбором противовесов на ободе',
    shortDescriptionEn: 'Balancing with clip-on or stick-on weights',
    fullDescriptionMn: 'Дугуйн балансыг тохируулахдаа жингийн хуваарилалтаас хамаарч обуд дээр ачаа зүүж өгдөг; өндөр хурдтай эргүүлж хаана хэр их жин байрлуулахыг тодорхойлно.',
    fullDescriptionRu: 'Подбор противовесов на ободе в зависимости от распределения массы; вращение колеса на высокой скорости для определения места и величины балансировочных грузов.',
    fullDescriptionEn: 'Weights are placed on the rim according to mass distribution; the wheel is spun at high speed to locate imbalance points.',
    prices: [
      p(4, 'Суудлын автомашин', 'Легковой автомобиль', 'Passenger car', 40000),
      p(5, 'Том машин / джип', 'Крупный автомобиль / внедорожник', 'Large vehicle / SUV', 60000),
    ],
  },
  {
    id: 4,
    slug: 'tenkhleg-tohirgoo',
    icon: '↔️',
    title: 'Развал-схождение',
    titleMn: 'Тэнхлэг тохиргоо',
    titleRu: 'Развал-схождение',
    titleEn: 'Wheel alignment',
    shortDescription: 'Углы и положение колёс по заводским нормам',
    shortDescriptionMn: 'Дугуйн өнцөг, байрлалыг стандартаар тохируулах',
    shortDescriptionRu: 'Регулировка углов установки колёс по нормам',
    shortDescriptionEn: 'Camber, toe and caster set to manufacturer specs',
    fullDescriptionMn: 'Дугуйн өнцөг, байрлалыг стандарт хэмжээнд тохируулж, жолоодлогын аюулгүй байдал, дугуйн жигд элэгдлийг хангана: өнцөг хэмжих, рулийн тэгш байдал, тэнхлэгийн гажилт, элэгдэл шалгах.',
    fullDescriptionRu: 'Выставление углов установки колёс по стандарту для безопасности управления и равномерного износа шин: измерение углов, рулевой реакции, проверка геометрии и люфтов.',
    fullDescriptionEn: 'Wheel angles adjusted to spec for safe steering and even tire wear: angle measurement, steering response, geometry and wear checks.',
    prices: [
      p(6, 'Хоёр дугуй', 'Два колеса', 'Two wheels', 40000),
      p(7, 'Дөрвөн дугуй', 'Четыре колеса', 'Four wheels', 60000),
    ],
  },
  {
    id: 5,
    slug: 'motor-tos-solikh',
    icon: '🛢️',
    title: 'Замена моторного масла',
    titleMn: 'Моторын тос солих',
    titleRu: 'Замена моторного масла',
    titleEn: 'Engine oil change',
    shortDescription: 'Полная замена масла и масляного фильтра',
    shortDescriptionMn: 'Моторын тос, тосны шүүрийг стандартаар сольж шинэчлэх',
    shortDescriptionRu: 'Полная замена моторного масла и масляного фильтра по регламенту',
    shortDescriptionEn: 'Engine oil and oil filter replaced to specification',
    fullDescriptionMn: 'Хөдөлгүүрийн эд ангийг элэгдлээс хамгаалж, хэвийн ажиллагааг хангах зорилгоор моторын тосыг стандартын дагуу бүрэн сольж, тосны шүүрийг шинэчилнэ.',
    fullDescriptionRu: 'Замена моторного масла и фильтра по стандарту для защиты узлов от износа, снижения шума и продления ресурса двигателя.',
    fullDescriptionEn: 'Oil and filter service to spec to protect the engine, reduce noise and extend service life.',
    prices: [
      p(8, 'Суудлын автомашин', 'Легковой автомобиль', 'Passenger car', 40000),
      p(9, 'Том машин / джип', 'Крупный автомобиль / внедорожник', 'Large vehicle / SUV', 60000),
    ],
  },
  {
    id: 6,
    slug: 'khrop-tos-solikh',
    icon: '⚙️',
    title: 'Замена масла в коробке передач',
    titleMn: 'Хропны тос солих',
    titleRu: 'Замена масла в коробке передач',
    titleEn: 'Transmission (gearbox) oil change',
    shortDescription: 'Замена масла в трансмиссии для ровного переключения',
    shortDescriptionMn: 'Хурдны хайрцгийн тосыг сольж араа дамжуулалтыг жигд ажиллуулна',
    shortDescriptionRu: 'Замена масла в трансмиссии для плавного переключения передач',
    shortDescriptionEn: 'Fresh gearbox oil for smooth shifting and driveline protection',
    fullDescriptionMn: 'Хроп / хурдны хайрцгийн тосыг сольж араа дамжуулалтын жигд ажиллагааг хангана: шилжилт сайжрах, хайрцаг хамгаалагдана.',
    fullDescriptionRu: 'Замена трансмиссионного масла для ровной работы передач и защиты узлов коробки передач.',
    fullDescriptionEn: 'Transmission fluid exchange for smoother gear changes and protection of the gearbox.',
    prices: [
      p(10, 'Суудлын автомашин', 'Легковой автомобиль', 'Passenger car', 40000),
      p(11, 'Том машин / джип', 'Крупный автомобиль / внедорожник', 'Large vehicle / SUV', 60000),
    ],
  },
  {
    id: 7,
    slug: 'buten-tseverlegee',
    icon: '✨',
    title: 'Комплексная очистка',
    titleMn: 'Бүтэн цэвэрлэгээ',
    titleRu: 'Комплексная очистка (коллектор, EGR, форсунки)',
    titleEn: 'Full intake cleaning (manifold, EGR, injectors)',
    shortDescription: 'Очистка впуска, EGR и форсунок от нагара',
    shortDescriptionMn: 'Коллектор, EGR, форсунк — агаар, түлшний системийн бохирдол арилгах',
    shortDescriptionRu: 'Очистка впускного коллектора, клапана EGR и форсунок',
    shortDescriptionEn: 'Manifold, EGR valve and injector decarbonizing',
    fullDescriptionMn: 'Хөдөлгүүрийн агаар, түлшний системд үүссэн бохирдлыг бүрэн цэвэрлэж хүч чадал, шаталтын үр ашгийг сэргээнэ: коллекторын нүүрсжилт, EGR-ийн хийн эргэлт, форсункын түлшний цацалт.',
    fullDescriptionRu: 'Полная очистка впускного тракта и топливной системы от нагара для восстановления мощности и КПД: коллектор, клапан EGR, форсунки; проверка воздушного потока и системы впрыска.',
    fullDescriptionEn: 'Deep clean of intake and fuel paths to restore power and efficiency: intake manifold, EGR circuit and injectors; airflow and combustion checks.',
    prices: [p(12, 'Бүх төрлийн автомашин', 'Все типы автомобилей', 'All vehicle types', 110000, 350000)],
  },
  {
    id: 8,
    slug: 'yavakh-angiin-zasvar',
    icon: '🔧',
    title: 'Запчасти и ремонт ходовой',
    titleMn: 'Явах эд ангийн сэлбэг худалдаа, засвар',
    titleRu: 'Запчасти и ремонт ходовой части',
    titleEn: 'Chassis parts sales and repair',
    shortDescription: 'Диагностика, ремонт и установка запчастей ходовой',
    shortDescriptionMn: 'Явах эд анги, агрегатуудын оношилгоо, засвар, сэлбэг',
    shortDescriptionRu: 'Диагностика, ремонт и установка запчастей подвески и агрегатов',
    shortDescriptionEn: 'Chassis diagnostics, repair and parts installation',
    fullDescriptionMn: 'Явах эд анги болон үндсэн агрегатуудын гэмтэл, элэгдлийг сэгсэрдэг оношилгоогоор оношилж, стандартын дагуу засварлах иж бүрэн үйлчилгээ. Үнэ: үйлчилгээний үнэ хэсгээс болон прайс-листээс үзнэ үү.',
    fullDescriptionRu: 'Полный цикл: вибродиагностика ходовой и агрегатов, ремонт и установка запчастей по стандарту. Актуальные цены — в разделе прайса и в Excel-прайс-листе.',
    fullDescriptionEn: 'Full service: vibration diagnostics of chassis and major assemblies, repair and parts to specification. See our price list for current labour and parts rates.',
    prices: [
      {
        id: 13,
        nameMn: 'Ажил болон сэлбэгийн үнэ',
        nameRu: 'Стоимость работ и запчастей',
        nameEn: 'Labour and parts',
        name: 'Стоимость работ и запчастей',
        priceTextMn: 'Прайс-листээр',
        priceTextRu: 'По прайс-листу',
        priceTextEn: 'Per price list',
        price: '',
        priceMinMnt: 0,
        priceMaxMnt: null,
      },
    ],
  },
];

// pt helper: added nameRu field
const pt = (id, model, modelTitle, cat, nameMn, nameEn, nameRu, qty, brand, price) => ({
  id, carModel: model, carModelTitle: modelTitle, category: cat,
  nameMn, nameEn, nameRu, quantity: qty, brand, priceMnt: price,
});

let _id = 1;

export const fallbackParts = [
  // ─── Land Cruiser 200 / Lexus 570 ───────────────────────────────────────────
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'oils',
    'Моторын тос (V6,V8)', 'Motor oil (V6,V8)', 'Моторное масло (V6,V8)', '6-8L', 'Wuerth', 65000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'oils',
    'Хропны тос (V6,V8)', 'Krop oil (V6,V8)', 'Трансмиссионное масло (V6,V8)', '7-9L', 'S-Oil Seven', 45000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'oils',
    'Маслын шүүр', 'Oil filter', 'Масляный фильтр', '1', 'Toyota', 35000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'oils',
    'Агаар шүүгч', 'Air filter', 'Воздушный фильтр', '1', 'Toyota', 45000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'oils',
    'Салоны агаар шүүгч', 'Cabin air filter', 'Фильтр салона', '1', 'Toyota', 45000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Амортизатор (урд)', 'Shock absorber (front)', 'Амортизатор (передний)', '2', 'Tokico', 500000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Амортизатор (хойд)', 'Shock absorber (rear)', 'Амортизатор (задний)', '2', 'Tokico', 480000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Босоо тэнцүүлэгч (урд)', 'Stabilizer link (front)', 'Стойка стабилизатора (передняя)', '2', '555', 85000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Босоо тэнцүүлэгч (хойд)', 'Stabilizer link (rear)', 'Стойка стабилизатора (задняя)', '2', '555', 85000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Амортизатор таваг', 'Shock mount', 'Опора амортизатора', '2', 'DSK', 120000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Пүрш (урд)', 'Coil spring (front)', 'Пружина подвески (передняя)', '2', 'SRR/Oldman', 185000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Пүрш (хойд)', 'Coil spring (rear)', 'Пружина подвески (задняя)', '2', 'SRR/Oldman', 185000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Наклад (урд)', 'Brake pads (front)', 'Тормозные колодки (передние)', '1', 'DSK', 150000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Наклад (хойд)', 'Brake pads (rear)', 'Тормозные колодки (задние)', '1', 'DSK', 150000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Доод өндгөн тулгуур', 'Ball joint', 'Шаровая опора', '2', '555', 225000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Цап (урд)', 'Hub bearing (front)', 'Ступичный подшипник (передний)', '2', 'DSK', 550000),
  pt(_id++, 'land200', 'Land Cruiser 200 / Lexus 570', 'parts',
    'Рулийн аппарат ком', 'Steering rack assy', 'Рулевая рейка в сборе', '1', 'SRR', 1650000),

  // ─── Prado 150 / Hilux ──────────────────────────────────────────────────────
  pt(_id++, 'prado150', 'Prado 120/150 / Hilux', 'oils',
    'Моторын тос', 'Motor oil', 'Моторное масло', '7L', 'Wuerth', 65000),
  pt(_id++, 'prado150', 'Prado 120/150 / Hilux', 'oils',
    'Хропны тос', 'Krop oil', 'Трансмиссионное масло', '6L', 'S-Oil Seven', 45000),
  pt(_id++, 'prado150', 'Prado 120/150 / Hilux', 'oils',
    'Маслын шүүр', 'Oil filter', 'Масляный фильтр', '1', 'Toyota', 20000),
  pt(_id++, 'prado150', 'Prado 120/150 / Hilux', 'parts',
    'Амортизатор (урд)', 'Shock absorber (front)', 'Амортизатор (передний)', '2', 'Tokico', 420000),
  pt(_id++, 'prado150', 'Prado 120/150 / Hilux', 'parts',
    'Амортизатор (хойд)', 'Shock absorber (rear)', 'Амортизатор (задний)', '2', 'Tokico', 420000),
  pt(_id++, 'prado150', 'Prado 120/150 / Hilux', 'parts',
    'Доод өндгөн тулгуур', 'Ball joint', 'Шаровая опора', '2', '555', 185000),
  pt(_id++, 'prado150', 'Prado 120/150 / Hilux', 'parts',
    'Цап (урд)', 'Hub bearing (front)', 'Ступичный подшипник (передний)', '2', 'DSK', 350000),
  pt(_id++, 'prado150', 'Prado 120/150 / Hilux', 'parts',
    'Цап (хойд)', 'Hub bearing (rear)', 'Ступичный подшипник (задний)', '2', 'DSK', 450000),
  pt(_id++, 'prado150', 'Prado 120/150 / Hilux', 'parts',
    'Рулийн аппарат', 'Steering rack', 'Рулевая рейка', '1', '', 1650000),

  // ─── Lexus RX ───────────────────────────────────────────────────────────────
  pt(_id++, 'lexus-rx', 'Lexus RX', 'oils',
    'Моторын тос', 'Motor oil', 'Моторное масло', '5L', 'Wuerth', 65000),
  pt(_id++, 'lexus-rx', 'Lexus RX', 'oils',
    'Хропны тос', 'Krop oil', 'Трансмиссионное масло', '4L', 'S-Oil Seven', 45000),
  pt(_id++, 'lexus-rx', 'Lexus RX', 'oils',
    'Маслын шүүр', 'Oil filter', 'Масляный фильтр', '1', 'Toyota', 15000),
  pt(_id++, 'lexus-rx', 'Lexus RX', 'parts',
    'Амортизатор (урд)', 'Shock absorber (front)', 'Амортизатор (передний)', '2', 'KYB', 480000),
  pt(_id++, 'lexus-rx', 'Lexus RX', 'parts',
    'Амортизатор (хойд)', 'Shock absorber (rear)', 'Амортизатор (задний)', '2', 'KYB', 420000),
  pt(_id++, 'lexus-rx', 'Lexus RX', 'parts',
    'Наклад (урд)', 'Brake pads (front)', 'Тормозные колодки (передние)', '1', 'DSK', 125000),
  pt(_id++, 'lexus-rx', 'Lexus RX', 'parts',
    'Наклад (хойд)', 'Brake pads (rear)', 'Тормозные колодки (задние)', '1', 'DSK', 125000),
  pt(_id++, 'lexus-rx', 'Lexus RX', 'parts',
    'Цап (урд)', 'Hub bearing (front)', 'Ступичный подшипник (передний)', '2', 'DSK', 125000),
  pt(_id++, 'lexus-rx', 'Lexus RX', 'parts',
    'Цап (хойд)', 'Hub bearing (rear)', 'Ступичный подшипник (задний)', '2', 'DSK', 210000),

  // ─── RAV4 / NX300 / Harrier ─────────────────────────────────────────────────
  pt(_id++, 'rav4', 'RAV4 / NX300 / Harrier', 'oils',
    'Моторын тос', 'Motor oil', 'Моторное масло', '4L', 'Wuerth', 65000),
  pt(_id++, 'rav4', 'RAV4 / NX300 / Harrier', 'oils',
    'Хропны тос', 'Krop oil', 'Трансмиссионное масло', '4L', 'S-Oil Seven', 45000),
  pt(_id++, 'rav4', 'RAV4 / NX300 / Harrier', 'oils',
    'Маслын шүүр', 'Oil filter', 'Масляный фильтр', '1', 'Toyota', 15000),
  pt(_id++, 'rav4', 'RAV4 / NX300 / Harrier', 'parts',
    'Амортизатор (урд)', 'Shock absorber (front)', 'Амортизатор (передний)', '2', 'KYB', 450000),
  pt(_id++, 'rav4', 'RAV4 / NX300 / Harrier', 'parts',
    'Амортизатор (хойд)', 'Shock absorber (rear)', 'Амортизатор (задний)', '2', 'KYB', 420000),
  pt(_id++, 'rav4', 'RAV4 / NX300 / Harrier', 'parts',
    'Цап (урд)', 'Hub bearing (front)', 'Ступичный подшипник (передний)', '2', 'DSK', 285000),
  pt(_id++, 'rav4', 'RAV4 / NX300 / Harrier', 'parts',
    'Цап (хойд)', 'Hub bearing (rear)', 'Ступичный подшипник (задний)', '2', 'DSK', 285000),

  // ─── Crown ──────────────────────────────────────────────────────────────────
  pt(_id++, 'crown', 'Crown', 'oils',
    'Моторын тос', 'Motor oil', 'Моторное масло', '5-6L', 'Wuerth', 65000),
  pt(_id++, 'crown', 'Crown', 'oils',
    'Хропны тос', 'Krop oil', 'Трансмиссионное масло', '4L', 'S-Oil Seven', 45000),
  pt(_id++, 'crown', 'Crown', 'oils',
    'Маслын шүүр', 'Oil filter', 'Масляный фильтр', '1', 'Toyota', 15000),
  pt(_id++, 'crown', 'Crown', 'parts',
    'Амортизатор (урд)', 'Shock absorber (front)', 'Амортизатор (передний)', '2', 'KYB', 450000),
  pt(_id++, 'crown', 'Crown', 'parts',
    'Амортизатор (хойд)', 'Shock absorber (rear)', 'Амортизатор (задний)', '2', 'KYB', 450000),
  pt(_id++, 'crown', 'Crown', 'parts',
    'Наклад (урд)', 'Brake pads (front)', 'Тормозные колодки (передние)', '1', 'DSK', 125000),
  pt(_id++, 'crown', 'Crown', 'parts',
    'Наклад (хойд)', 'Brake pads (rear)', 'Тормозные колодки (задние)', '1', 'DSK', 125000),

  // ─── Prius 30 ───────────────────────────────────────────────────────────────
  // Масла и фильтры
  pt(_id++, 'prius30', 'Prius 30', 'oils',
    'Моторын тос', 'Motor oil', 'Моторное масло', '4L', 'S-OIL SEVEN KOREA', 35000),
  pt(_id++, 'prius30', 'Prius 30', 'oils',
    'Хропны тос', 'Krop oil', 'Трансмиссионное масло', '4L', 'S-OIL SEVEN KOREA', 45000),
  pt(_id++, 'prius30', 'Prius 30', 'oils',
    'Маслын шүүр', 'Oil filter', 'Масляный фильтр', '1', 'Toyota', 10000),
  pt(_id++, 'prius30', 'Prius 30', 'oils',
    'Агаар шүүгч', 'Air filter', 'Воздушный фильтр', '1', 'Toyota', 10000),
  pt(_id++, 'prius30', 'Prius 30', 'oils',
    'Салоны агаар шүүгч', 'Cabin air filter', 'Фильтр салона', '1', 'Toyota', 10000),
  // Запчасти ходовой
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Амортизатор (урд)', 'Shock absorber (front)', 'Амортизатор (передний)', '2', 'SRR', 185000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Амортизатор (хойд)', 'Shock absorber (rear)', 'Амортизатор (задний)', '2', 'SRR', 185000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Амортизатор (урд) таваг', 'Shock mount (front)', 'Опора амортизатора (передняя)', '2', '', 85000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Пүрш (урд, хойд)', 'Coil spring (FR, RR)', 'Пружина подвески (перед. и зад.)', '4', 'DSK', 65000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Босоо тэнцүүлэгч (урд) — LINKASSY,FR', 'Stabilizer link FR (1)', 'Стойка стабилизатора (пер.) — 1', '1', 'DSK', 55000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Босоо тэнцүүлэгч (урд) — LINKASSY,FR', 'Stabilizer link FR (2)', 'Стойка стабилизатора (пер.) — 2', '1', 'DSK', 55000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Хэвтээ тэнцүүлэгчийн резин — BUSH,STABILIZER', 'Stabilizer bush', 'Втулка стабилизатора (передняя)', '1', 'DSK', 45000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Хэвтээ тэнцүүлэгчийн резин — BUSH,STABILIZER,RR', 'Stabilizer bush RR', 'Втулка стабилизатора (задняя)', '1', 'DSK', 45000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Наклад (урд)', 'Brake pads (front)', 'Тормозные колодки (передние)', '1', 'DSK', 85000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Наклад (хойд)', 'Brake pads (rear)', 'Тормозные колодки (задние)', '1', 'DSK', 85000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Рулийн аппарат', 'Steering rack assy', 'Рулевая рейка в сборе', '1', '', 450000),
  pt(_id++, 'prius30', 'Prius 30', 'parts',
    'Рулийн аппарат ажлын хөлс', 'Steering rack (labour)', 'Рулевая рейка (стоимость работы)', '1', '', 120000),

  // ─── Lexus HS250 / Sai ──────────────────────────────────────────────────────
  // Масла и фильтры
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'oils',
    'Моторын тос', 'Motor oil', 'Моторное масло', '4L', 'WUERTH GERMAN', 65000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'oils',
    'Хропны тос', 'Krop oil', 'Трансмиссионное масло', '4L', 'S-OIL SEVEN', 45000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'oils',
    'Антифриз', 'Antifreeze', 'Антифриз', '8L', '50C KOREA', 15000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'oils',
    'Маслын шүүр', 'Oil filter', 'Масляный фильтр', '1', 'Toyota', 15000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'oils',
    'Агаар шүүгч', 'Air filter', 'Воздушный фильтр', '1', 'Toyota', 15000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'oils',
    'Салоны агаар шүүгч', 'Cabin air filter', 'Фильтр салона', '1', 'Toyota', 15000),
  // Запчасти ходовой
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Амортизатор (урд)', 'Shock absorber (front)', 'Амортизатор (передний)', '2', 'KYB', 370000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Амортизатор (хойд)', 'Shock absorber (rear)', 'Амортизатор (задний)', '2', 'KYB', 370000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Пүрш (урд, хойд)', 'Coil spring (FR, RR)', 'Пружина подвески (перед. и зад.)', '4', 'DSK', 85000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Босоо тэнцүүлэгч (урд) — LINKASSY,FR (1)', 'Stabilizer link FR (1)', 'Стойка стабилизатора (пер.) — 1', '1', '555 THREE FIVE', 75000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Босоо тэнцүүлэгч (урд) — LINKASSY,FR (2)', 'Stabilizer link FR (2)', 'Стойка стабилизатора (пер.) — 2', '1', '555 THREE FIVE', 75000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Босоо тэнцүүлэгч (хойд)', 'Stabilizer link RR', 'Стойка стабилизатора (задняя)', '2', '555 THREE FIVE', 75000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Амортизатор таваг', 'Shock mount (front)', 'Опора амортизатора (передняя)', '2', 'DSK', 95000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Өндгөн тулгуур', 'Ball joint', 'Шаровая опора', '2', '555 THREE FIVE', 125000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Хэвтээ тэнцүүлэгчийн резин — BUSH,STABILIZER', 'Stabilizer bush (front)', 'Втулка стабилизатора (передняя)', '1', 'DSK', 45000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Хэвтээ тэнцүүлэгчийн резин — BUSH,STABILIZER,RR', 'Stabilizer bush (rear)', 'Втулка стабилизатора (задняя)', '1', 'DSK', 45000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Наклад (урд)', 'Brake pads (front)', 'Тормозные колодки (передние)', '1', 'DSK', 125000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Наклад (хойд)', 'Brake pads (rear)', 'Тормозные колодки (задние)', '1', 'DSK', 125000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Рулийн аппарат-н шарнир', 'Outer tie rod end', 'Наконечник рулевой тяги', '2', '555 THREE FIVE', 125000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Рулийн аппарат ком', 'Inner tie rod end', 'Внутренний наконечник рулевой тяги', '1', '555 THREE FIVE', 650000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Саран татуурга', 'Arm rear axle front', 'Задний рычаг (передний)', '2', 'DSK', 165000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Далан гар', 'Arm rear axle rear', 'Задний рычаг (задний)', '2', 'DSK', 125000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Шарнертэй татуурга', 'Arm rear with outer tie rod end', 'Рычаг с наконечником (задний)', '2', 'DSK', 125000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Доод гар', 'Front lower arm RH LH', 'Нижний рычаг (лев./прав.)', '2', 'DSK', 185000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Цап урд', 'Hub bearing front', 'Ступичный подшипник (передний)', '2', 'DSK', 185000),
  pt(_id++, 'hs250', 'Lexus HS250 / Sai', 'parts',
    'Цап хойд', 'Hub bearing rear', 'Ступичный подшипник (задний)', '2', 'DSK', 185000),
];